<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="bankModal"
    >   
        <CForm>
            <CRow>
              <CCol md="8">
                <CInput
                  label="Nombre:"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
              <CCol md="4">
                <CInput
                  label="Identificador:"
                  :lazy="false"
                  :value.sync="$v.form.identifier.$model"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <CInput
                  label="Banco:"
                  :lazy="false"
                  :value.sync="$v.form.bank.$model"
                />
              </CCol>
              <CCol md="4">
                <CInput
                  label="Cuenta:"
                  :lazy="false"
                  :value.sync="$v.form.number.$model"
                />
              </CCol>
              <CCol md="4">
                <CInput
                  label="Clabe:"
                  :lazy="false"
                  :value.sync="$v.form.clabe.$model"
                />
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"
import ws from '../../services/bank_accounts';

export default {
  name: 'BankModal',
  props: {

  },
  data () {
    return {
      bankModal: false,
      title: "Nueva Cuenta",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      fields: [
        {key: 'name', label: 'Nombre'},
        {key: 'actions', label: '', class: 'actions' }
      ]
    }
  },
  mounted: async function() {
    
  },
  methods: {
    storeModal () {
      this.bankModal = true;
      this.color = "info";
      this.title = 'Nueva Cuenta';
      this.isEdit = false;
      this.submitted = false;

      this.form = this.getEmptyForm();
    },
    updateModal (item) {
      this.bankModal = true;
      this.color = "warning";
      this.title = 'Editar Cuenta';
      this.isEdit = true;
      this.submitted = false;

      this.form = {
          id: item.id,
          identifier: item.identifier,
          name: item.name,
          bank: item.bank_name,
          number: item.account_number,
          clabe: item.account_clabe
      };
    },
    store () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        if(this.form.id > 0){
          this.$emit("update", this.form );
        }
        else{
          this.$emit("store", this.form );
        }

        this.closeModal();
      }
    },
    closeModal () {
      this.bankModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          identifier: '',
          name: '',
          bank: '',
          number: '',
          clabe: ''
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      identifier: {},
      name: {
        required
      },
      bank: {},
      number: {},
      clabe: {}
    }
  },
}
</script>